import React from 'react';
import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';

import ImageBase64 from '@Components/ImageBase64';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { sanitizeDiscard } from '@Services/HtmlSanitizeService';

import useStructureSrc from './useStructureSrc';

export default function StructureToBase64({ structure, customRenderer, structureName }) {
  const src = useStructureSrc(structure);

  if (!structure) {
    return null;
  }

  // Determine alt text based on structureName type
  let altText = 'chemical structure';
  if (structureName) {
    if (structureName.isLinearFormula) {
      altText = `Linear formula of ${sanitizeDiscard(structureName.name, { allowedTags: [] })}`;
    } else if (typeof structureName === 'string') {
      altText = `chemical structure of ${sanitizeDiscard(structureName, { allowedTags: [] })}`;
    }
  }

  const renderImage = (imgSrc) => {
    if (isFunction(customRenderer)) {
      return customRenderer({ src: imgSrc });
    }
    return <img className="structure-dialog--image" src={imgSrc} alt={altText} />;
  };

  return (
    <ImageBase64 src={src}>
      {/* eslint-disable-next-line no-shadow */}
      {({ src }) => (src ? renderImage(src) : <SimpleSpinner />)}
    </ImageBase64>
  );
}

StructureToBase64.propTypes = {
  structure: PropTypes.string,
  customRenderer: PropTypes.func,
  structureName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
